import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=6d9d83a4"
import script from "./Menus.vue?vue&type=script&lang=ts"
export * from "./Menus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports